var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MarketingSucceed"},[_vm._m(0),_c('div',{staticClass:"btn"},[_c('el-button',{staticClass:"btn-blue-line-all",on:{"click":_vm.toList}},[_vm._v("返回")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-content"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',{staticClass:"text"},[_vm._v("创建成功！")])])
}]

export { render, staticRenderFns }